import BootScreen from './BootScreen';

export default BootScreen;